import { OrganizationJson } from '~/data/user/organization/OrganizationJson'
import { Organization } from '~/domain/user/Organization'

export function mapJsonToOrganization(json: OrganizationJson): Organization {
  return {
    id: json.slug,
    name: json.name,
  }
}
